import localForage = require('localforage')
import { OfflineRequest } from 'views/AdjustersHub/interfces'

const offlineRequests = localForage.createInstance({
  name: 'offline-requests',
})

export const OfflineRequestsService = {
  saveRequest: async (request: OfflineRequest) => {
    const date = Date.now().toString()
    await offlineRequests.setItem(date, { ...request, requestID: date })
  },
  getRequests: async () => {
    const keys = await offlineRequests.keys()

    const requests = await Promise.all(
      keys.map(async (key) => {
        const awaitedItem = await offlineRequests.getItem(key)

        return awaitedItem
      })
    )
    return requests
  },
  deleteRequest: async (key: string) => {
    await offlineRequests.removeItem(key)
  },
}
